<ms-nav-tree msTreeScroll [tree]="tree" (toggle)="toggleItem($event)" (selectEvent)="onSelectEvent($event)" (toggleMarkets)="onToggleMarkets($event)">
</ms-nav-tree>
